"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryTypes = exports.ProductListingContext = void 0;
var _react = require("react");
// a react context for product listing page components to share categories, tiles, and tags

const ProductListingContext = exports.ProductListingContext = /*#__PURE__*/(0, _react.createContext)();
const categoryTypes = exports.categoryTypes = {
  BUNDLE: 'bundle',
  PRODUCT: 'product'
};